import { render, staticRenderFns } from "./SeleccionEspecial.vue?vue&type=template&id=fc3977f8&"
import script from "./SeleccionEspecial.vue?vue&type=script&lang=js&"
export * from "./SeleccionEspecial.vue?vue&type=script&lang=js&"
import style0 from "./SeleccionEspecial.vue?vue&type=style&index=0&id=fc3977f8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports